import { ISearchResult } from '@common/interfaces/search'
import { combineReducers } from 'redux'
import { IAction, IActionWithParams } from '../apiMiddleware'
import * as actions from './actions'

interface ISearchResultsState {
  results: ISearchResult[]
  latestRequestId?: number
}

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.SEARCH_REQUEST:
        return [...state, action.type]
      case actions.SEARCH_SUCCESS:
      case actions.SEARCH_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  searchString(state: string = '', action: IActionWithParams<{ search?: string }>): string {
    switch (action.type) {
      case actions.SEARCH_REQUEST:
        return action.params?.search || ''
      default:
        return state
    }
  },
  /**
   * The rows, plus which search they belong to.
   *
   * This slice predates `createLoadingDataReducer`, so it does not get that
   * reducer's supersede guard for free — and it needs one, because
   * GlobalSearchPage renders these rows from the store rather than from the
   * component that asked for them. A broad search fired first can return after
   * the narrower one typed next, leaving the page showing an answer to a question
   * the reader has already moved past.
   *
   * The id is stamped by apiMiddleware on the REQUEST and carried to its reply.
   */
  searchResults(
    state: ISearchResultsState = { results: [] },
    action: IAction,
  ): ISearchResultsState {
    switch (action.type) {
      case actions.SEARCH_REQUEST:
        return { ...state, latestRequestId: action.requestId }
      case actions.SEARCH_SUCCESS: {
        const isSuperseded =
          action.requestId !== undefined &&
          state.latestRequestId !== undefined &&
          action.requestId !== state.latestRequestId
        if (isSuperseded) return state
        return { ...state, results: action.data as ISearchResult[] }
      }
      default:
        return state
    }
  },
})
